module.exports = __webpack_public_path__ + "static/media/chapter-33-image-02.e2caa7f4.png";